export default "__VITE_ASSET__xrdQaFcI__"